"use client";

/**
 * @ccheng/ui Sidebar 的 linkComponent 接線：讓側欄項目走 next/link（client-side
 * navigation）而非預設 <a href>（整頁重載）。signature 需與 SidebarProps["linkComponent"] 一致。
 */
import Link from "next/link";
import type { ReactNode } from "react";

export function NextNavLink({
  href,
  className,
  children,
}: {
  href: string;
  className: string;
  children: ReactNode;
}) {
  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
}
